<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  listing: { type: Object, default: null },
  property: { type: Object, default: null },
});

const emit = defineEmits(['confirm']);
const { t } = useI18n();
</script>

<template>
  <div>
    <LaisCard
      v-if="property"
      :title="t('SALES.CREATE.PREVIEW_TITLE')"
      prefix-icon="i-lucide-map-pin"
      class="w-full"
    >
      <div class="grid gap-5 lg:grid-cols-[minmax(0,1fr)_240px]">
        <div class="grid gap-3">
          <div>
            <p
              class="text-xs font-semibold uppercase tracking-wide text-lais-text-muted"
            >
              {{ t('SALES.CREATE.PROPERTY_CODE') }}
            </p>
            <p class="mt-1 text-base font-semibold text-lais-text">
              {{ property.external_id || t('SALES.COMMON.NO_DATA') }}
            </p>
          </div>
          <div>
            <p
              class="text-xs font-semibold uppercase tracking-wide text-lais-text-muted"
            >
              {{ t('SALES.CREATE.ADDRESS') }}
            </p>
            <p class="mt-1 text-sm text-lais-text">
              {{ property.endereco || t('SALES.COMMON.ADDRESS_UNAVAILABLE') }}
            </p>
            <p class="text-sm text-lais-text-muted">
              {{
                [property.bairro, property.cidade, property.uf]
                  .filter(Boolean)
                  .join(' · ')
              }}
            </p>
            <p v-if="property.unidade" class="text-sm text-lais-text-muted">
              {{ property.unidade }}
            </p>
          </div>
          <div v-if="listing" class="rounded-lais-sm bg-lais-bg-soft p-3">
            <p
              class="text-xs font-semibold uppercase tracking-wide text-lais-text-muted"
            >
              {{ t('SALES.CREATE.SALE_LISTING') }}
            </p>
            <p class="mt-1 text-sm font-semibold text-lais-text">
              {{ listing.titulo || property.titulo }}
            </p>
            <p
              v-if="listing.price_amount"
              class="mt-1 text-sm text-lais-text-muted"
            >
              {{ listing.currency }} {{ listing.price_amount }}
            </p>
          </div>
        </div>
        <div
          class="grid min-h-36 place-items-center rounded-lais bg-lais-primary-50/40 text-center"
        >
          <div>
            <span
              class="i-lucide-map-pin-house mx-auto size-10 text-lais-primary"
              aria-hidden="true"
            />
            <p class="mt-2 text-xs font-semibold text-lais-primary">
              {{ t('SALES.CREATE.LOCATION_PREVIEW') }}
            </p>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="flex justify-end">
          <LaisPrimaryButton
            size="lg"
            icon="i-lucide-check"
            @click="emit('confirm')"
          >
            {{ t('SALES.CREATE.CONFIRM_PROPERTY') }}
          </LaisPrimaryButton>
        </div>
      </template>
    </LaisCard>
  </div>
</template>
